module.exports = __webpack_public_path__ + "img/E6.e2bddd6e.png";